import { render, staticRenderFns } from "./onlinefooter.vue?vue&type=template&id=79b840d7&"
import script from "./onlinefooter.vue?vue&type=script&lang=js&"
export * from "./onlinefooter.vue?vue&type=script&lang=js&"
import style0 from "./onlinefooter.vue?vue&type=style&index=0&id=79b840d7&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports